import { Unsubscriber } from 'easy-signal';

export function addListener(node: EventTarget, event: string, handler: EventListener): Unsubscriber {
  node.addEventListener(event, handler);
  return () => node.removeEventListener(event, handler);
}
